module.exports = __webpack_public_path__ + "static/media/dough.ce0b5af0.png";